import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RestaurantPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  ECommerceB2cRestaurantModule,
  RecipeManagementModule,
  KdsModule,
} from "./CommonModules";

import CartContext from "./CartContext";
import { ECommerceB2CRetail } from "./ECommerceB2cRetail";

export class ErpRestaurant extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    } else {
      const selected = prods.find(
        (p) => p.productType === ProductType.Retail_ERP
      );
      SetSelectedProduct(selected);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        /* Hero Section */
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row gx-5">
              <div className="col-12 border-start border-5 border-primary ps-3 mb-2">
                <h6 className="text-primary text-uppercase">
                  End-to-End solution for Dine-in/CAFE/Fastfood Restaurants
                </h6>
                <h2 className="display-6 fw-bold">
                  All-In-One Solution for Restaurants (ERP)
                </h2>
              </div>
              <p>
                We cover all use cases that are required to run all type of
                restaurants with ease.
                <br /> Our ERP modules are designed to be{" "}
                <strong>easy to use</strong> and <strong>affordable</strong>.
              </p>
              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "RestaurantErpVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              <Row className="align-items-center mb-4">
                <Col md={6}>
                  <h4 className="display-6  mb-0">Features and Benefits</h4>
                </Col>
                <Col md={6} className="text-end">
                  <Button
                    variant="warning"
                    className="w-100"
                    as={Link}
                    to="/Checkout"
                    onClick={(e) =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.Restaurant_ERP
                      )
                    }
                  >
                    Buy
                  </Button>
                </Col>
              </Row>
              <div className="col-lg-12">
                <div className="bg-light p-4 rounded shadow-sm">
                  {/* POS Feature Sections */}
                  <FeatureSection
                    title="Features & Benefits"
                    items={[
                      "Point-Of-Sale (POS)",
                      "Table Orders Management(Captain App)",
                      "ECommerce B2C website",
                      "Purchase/Procurement Management",
                      "Suppliers Management",
                      "Inventory & Stocks Management",
                      "Orders Management",
                      "Packaging Management(Kitchen Display System)",
                      "Delivery Management",
                      "return and refund management",
                      "Customer Relationship Management (CRM)",
                      "Coupons Management",
                      "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateway Integration",
                      "HR & Payroll Management",
                      "Accounting & Balance Sheet",
                      "AI-powered solutions",
                      "Real-time dashboard with sales, billing, and inventory reports",
                      "Advanced Reporting and Analytics",
                      "Multi-Store, Multi-Vendor, Multi-Currency",
                      "Free SSL and Custom domain",
                      "Use on any device: Phone, Tablet, or PC",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ERP Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4">
            Explore Integrated ERP Modules That Power Your Business
          </h5>
          <Row className="g-3">
            {[
              RestaurantPosModule,
              ECommerceB2cRestaurantModule,
              PurchasesModule,
              InventoryModule,
              RecipeManagementModule,
              OrdersManagementModule,
              KdsModule,
              DeliveryManagementModule,
              CrmModule,
              LeadsManagementModule,
              CouponsManagementModule,
              HrmModule,
              AccountingModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  <Module />
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

// Reusable FeatureSection component
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    {/* <h6 className="fw-semibold">{title}</h6> */}
    <Row>
      {items.map((item, idx) => (
        <Col md={6} key={idx}>
          <li className="mb-2">{item}</li>
          {/* <li key={idx}>{item}</li> */}
        </Col>
      ))}
    </Row>
  </div>
);
